
export const getStatusColor = (status: string) => {
  switch (status) {
    case "approved": return "bg-emerald-500 text-white";
    case "rejected": return "bg-red-500 text-white";
    case "pending": return "bg-amber-500 text-white";
    case "completed": return "bg-blue-500 text-white";
    case "active": return "bg-green-500 text-white";
    case "paused": return "bg-orange-500 text-white";
    default: return "bg-gray-500 text-white";
  }
};

export const getStatusText = (status: string, language: string) => {
  if (language === 'ar') {
    switch (status) {
      case "approved": return "موافق عليها";
      case "rejected": return "مرفوضة";
      case "pending": return "في انتظار المراجعة";
      case "completed": return "مكتملة";
      case "active": return "نشطة";
      case "paused": return "متوقفة";
      default: return status;
    }
  }
  
  switch (status) {
    case "approved": return "Approved";
    case "rejected": return "Rejected";
    case "pending": return "Pending";
    case "completed": return "Completed";
    case "active": return "Active";
    case "paused": return "Paused";
    default: return status.charAt(0).toUpperCase() + status.slice(1);
  }
};
